// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAccordion_container___t5do","title":"TermsAccordion_title__TlBwT","icon":"TermsAccordion_icon__EkqIc","content":"TermsAccordion_content__2fvcE"};